// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomLightning = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.92394 4.22888L7.64193 3.26392L8.83761 1.65695C8.91426 1.55394 9.07792 1.60815 9.07792 1.73654V6.81507C9.07792 6.88871 9.13761 6.9484 9.21125 6.9484H12.0044C12.2785 6.9484 12.4354 7.26082 12.2718 7.48072L7.16426 14.3452C7.08761 14.4482 6.92395 14.394 6.92395 14.2656V9.18705C6.92395 9.11341 6.86426 9.05371 6.79062 9.05371H3.99749C3.72339 9.05371 3.56644 8.7413 3.73006 8.5214L4.76997 7.12378L5.48796 6.15881',
      stroke: 'currentColor',
      strokeLinecap: 'round',
    }),
  );

export { IconCustomLightning };
